import { useRef, useState,forwardRef,useImperativeHandle} from 'react'
import { Blade} from 'components'
import { InputFormField } from "components/hookForm"
import { updateBulkUpdateGZC } from 'api'
import { Container, Toast as toast} from 'components'
import { reportException } from 'tools/logs';
import { useForm, FormProvider } from 'react-hook-form'
import { IconButton, Select, MenuItem, FormControl, InputLabel } from '@mui/material'
import EditIcon from "@mui/icons-material/Edit";
import { validateGZCByCountry } from 'tools/validators'
import strings from 'strings'
import { SUPPORTED_COUNTRIES, DEFAULT_COUNTRY, FORM_FIELDS } from 'constants/garagingZipcodeConfig'

export interface ApiRefBulkGZC{setListIndexGZC: (params: any) => void }
interface ApiProps{handleSaveSon: () => void, row: any}
interface ApiRowProps{row: any}
interface InputManualGZC {
  getValue: () => any
  validateForm?: () => Promise<boolean>;
}

const InputBulk = forwardRef<InputManualGZC,ApiRowProps>((props, ref)=>{
    
  const getValue = ()=>{
    return {
      manualGzc: getValues(FORM_FIELDS.MANUAL_GZC_EDIT),
      country: getValues(FORM_FIELDS.COUNTRY)
    }
  }

  const methods = useForm<any>({
    reValidateMode: 'onChange',
    mode: 'all',
    defaultValues: {
      [FORM_FIELDS.MANUAL_GZC_EDIT]: props.row.manualGzc ?? "",
      [FORM_FIELDS.COUNTRY]: props.row.manualCountry || props.row.country || DEFAULT_COUNTRY
    }
  })

  const { getValues, setValue, watch } = methods
  const countryValue = watch(FORM_FIELDS.COUNTRY)

  useImperativeHandle(ref,()=>({
    getValue,
    validateForm: () => methods.trigger(FORM_FIELDS.MANUAL_GZC_EDIT)
  }))

  return (
        <div style={{'display': 'flex', 'flexDirection': 'column', 'gap': '1rem'}}>
          <FormProvider {...methods}>
          <InputFormField
              id={"id_" + props.row.assetEldId}
              name="VIN"
              label={"VIN"}
              maxLength={100}
              disabled={true}
              value={props.row.vin}
            />
            <InputFormField
              id={"autoGZC_" + props.row.assetEldId}
              name="automaticGzc"
              label={strings.MANUAL_GZC.AUTOMATIC_GZC_LABEL}
              maxLength={100}
              disabled={true}
              value={props.row.automaticGzc}
            />
            <FormControl fullWidth style={{ marginTop: '0.5rem' }}>
              <InputLabel id="country-label">{strings.MANUAL_GZC.COUNTRY_LABEL}</InputLabel>
              <Select
                labelId="country-label"
                id={"country_" + props.row.assetEldId}
                value={countryValue}
                label={strings.MANUAL_GZC.COUNTRY_LABEL}
                onChange={(e) => setValue(FORM_FIELDS.COUNTRY, e.target.value)}
              >
                {SUPPORTED_COUNTRIES.map((country) => (
                  <MenuItem key={country.code} value={country.code}>
                    {country.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <InputFormField 
                id={"manualGZC_" + props.row.assetEldId}
                type="text" 
                label={strings.MANUAL_GZC.LABEL}
                name={FORM_FIELDS.MANUAL_GZC_EDIT}
                validate={(value: string) => validateGZCByCountry(value, countryValue)}                
                className="border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            </FormProvider>  
         </div> 
  )
})

const EditIndividualManualGZC = forwardRef<ApiRefBulkGZC,ApiProps>((props, ref)=>{

  const [loading, setLoading] = useState(false)
  const inputRef = useRef<InputManualGZC>(null)
  const [hasCheckedEdit, setHasCheckedEdit] = useState(false)
 

  const handleCloseEditBulkManualGZC = () => {
    setHasCheckedEdit(false)
  }

  const handleSubmitBulkManualGZC = async () => {
    const isValid = await inputRef.current?.validateForm?.();
    let listAsset = [props.row.assetEldId]
    const formValues = inputRef.current?.getValue()
      const payload={      
        listAssetEldId: listAsset ? listAsset : null,      
        manualGzc: formValues?.manualGzc || null,
        country: formValues?.country || DEFAULT_COUNTRY
      }  
    if (!isValid) {
      return; // Stop submission if validation fails
    }else{
      props.row.manualGzc = formValues?.manualGzc
      props.row.manualCountry = formValues?.country
      setLoading(true)
    }
    
    updateBulkUpdateGZC(
      payload,
      localStorage.getItem('carrierId') ?? '',
      localStorage.getItem('carrierCodeType') ?? '',
      localStorage.getItem('carrierCodeValue') ?? ''
    )
      .then((res: any) => {
        toast({ id: 'updateBulkGzc', type: 'success', subTitle: res?.message })
        // Only close the blade after successful response
        handleCloseEditBulkManualGZC()
        // Update parent with minimal refreshing to preserve pagination
        setTimeout(() => {
          props.handleSaveSon()
        }, 100) // Short delay to ensure DOM is ready
      })
      .catch((error: any) => {
        reportException(error)
        setLoading(false)
      })
  }
 
  const handleOpenModalBulkGZC = (e: any) => {
      setHasCheckedEdit(true)
      e.stopPropagation();

  }
 
  return (<div> 
  <Container>
        <div> 
            <IconButton 
              onClick={(e) => handleOpenModalBulkGZC(e)}>
              <EditIcon/>              
            </IconButton>                  
        </div>
  </Container>

  <Blade
  open={hasCheckedEdit}
  title={strings.MANUAL_GZC.EDIT_TITLE}
  onClose={handleCloseEditBulkManualGZC}
  bodyNode={<InputBulk ref={inputRef} row={props.row}></InputBulk>}   
  footerBtns={{
    primary: {
      id: "createOrUpdateBulkManualGZC",
      label: 'Save',
      onClick: handleSubmitBulkManualGZC,
      disabled: false,  
      loading: loading    
    },
    secondary: {
      id: "closeBulkManualGZC",
      label: 'Close',
      variant: 'outlined',
      onClick: handleCloseEditBulkManualGZC,
    },
  }}
/>
</div>
)
})

export default EditIndividualManualGZC 
